import * as types from "@/store/constants/types";
export default {
  [types.RECEIVE_INS_USER_INFO_DATA](state: any, payLoad: any) {
    const { insUserInfo, userId } = payLoad;
    const findUser = state.insUserList.find((user: any) => {
      return user.userId.toString() === userId.toString();
    });
    if (findUser === undefined || findUser === null) {
      state.insUserList.push({
        userId,
        insUserInfo,
        dataStatus: "ready"
      });
    } else {
      findUser.insUserInfo = insUserInfo;
      findUser.dataStatus !== "ready"
        ? (findUser.dataStatus = "ready")
        : void 3;
    }
  },
  [types.MERGE_INS_USER_INFO_DATA](state: any, payLoad: any) {
    const { insUserInfo, userId } = payLoad;
    const findUser = state.insUserList.find((user: any) => {
      return user.userId.toString() === userId.toString();
    });
    if (findUser === undefined || findUser === null) {
      void 0;
    } else {
      const newInsUserInfo = {
        ...findUser.insUserInfo,
        ...insUserInfo
      };
      findUser.insUserInfo = newInsUserInfo;
      findUser.dataStatus !== "ready"
        ? (findUser.dataStatus = "ready")
        : void 0;
    }
  }
};
